<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2024.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2024-08-29                                                         -
  ----------------------------------------------------------------------------->

<template>
  <b-container>
    <b-row>
      <b-col>
        <b-card no-body class="m-3" v-for="category_node in category_nodes" :key="category_node.id">
          <b-card-header header-bg-variant="secondary" header-text-variant="white">
            {{ category_node.name }}
          </b-card-header>
          <b-card-body>
            <b-container>
              <b-row>
                <b-col sm="12" md="12" lg="6" xl="4" v-for="node in nodes_by_category_node_id[category_node.id]" :key="node.id">
                  <b-card class="mb-3">
                    <b-card-title v-if="productTitle(node)">
                      {{productTitle(node)}}
                    </b-card-title>
                    <b-card-sub-title v-if="productSubtitle(node)">
                      {{productSubtitle(node)}}
                    </b-card-sub-title>
                    <b-card-text>
                      <div v-if="productText(node)">
                        {{productText(node)}}
                      </div>
                      <ul v-if="productBullets(node).length > 0">
                        <li v-for="text_item in productBullets(node)">{{text_item}}</li>
                      </ul>
                      <p class="text-secondary m-3"><strong>MSRP {{formatCurrency(node.calculated_price_transformations['esup'])}}</strong></p>
                    </b-card-text>
                    <b-button variant="primary" v-on:click="addToQuote(node)">Add To Quote</b-button>
                    <b-button v-if="productInfoHref(node)" variant="outline-primary" class="ml-3" :href="productInfoHref(node)" target="_blank" rel="noopener noreferrer">Read More</b-button>
                  </b-card>
                </b-col>
              </b-row>
            </b-container>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import ConfigureMixin from "@/components/dynabook_shared/configure-mixin";
import YesNo from "@/enums/yes-no";
import IsSelected from "@/enums/is-selected";
import useCurrencyFormatter from "@/compositions/use-currency-formatter";

export default {
  name: "product-category-assignment-non-bto-cards",
  mixins: [ConfigureMixin],
  setup(){
    const { formatCurrency } = useCurrencyFormatter();
    return {
      formatCurrency
    };
  },
  components: {},
  props: {
    templateId: {
      type: Number,
      required: true
    },
    isPublic: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    category_nodes() {
      return this.template_version.nodes
          .filter((node) => {
            return node.attribute_store['item-type'] === 'category';
          })
          .sort((node1, node2) => {
            if (node1.attribute_store['order'] < node2.attribute_store['order']) {
              return -1;
            }
            if (node1.attribute_store['order'] > node2.attribute_store['order']) {
              return 1;
            }
            return 0;
          });
    },
    nodes_by_category_node_id() {
      return this.category_nodes.reduce((object, category_node) => {
        object[category_node.id] =
            this.template_version.nodes.filter((node) => {
              return node.attribute_store['item-type'] === 'content' &&
                  node.attribute_store['category'] === category_node.attribute_store['category'] &&
                  node.attribute_store['hide-on-standard-dialog'] !== YesNo.YES;
            }).sort((node1, node2) => {
              if (node1.attribute_store['order'] < node2.attribute_store['order']) {
                return -1;
              }
              if (node1.attribute_store['order'] > node2.attribute_store['order']) {
                return 1;
              }
              return 0;
            });
        return object;
      }, {});
    },
  },
  methods:{
    addToQuote(node){
      node.is_selected = IsSelected.YES;
      if(this.isPublic){
        this.savePublicProduct();
      }else{
        this.saveOtherProduct();
      }
    },
    savePublicProduct(){
      this.$store
          .dispatch('PublicQuoteProductsStore/create', {
            cfg_template_version_id: this.quote_product.cfg_template_version_id,
            cfg_item_ids: this.quote_product.cfg_item_ids
          })
          .then((savedItem) => {
            this.productSaveCompleted();
          })
          .catch((error) => {
            alert(error.response ? error.response.data : error);
          });
    },
    saveOtherProduct(){
      this.$store
          .dispatch('QuoteProductsStore/create', {
            quote_part_id: this.$route.params.quote_part_id,
            cfg_template_version_id: this.quote_product.cfg_template_version_id,
            cfg_item_ids: this.quote_product.cfg_item_ids,
            attributes_string:this.quote_product.attributes_string,
            detail_attributes_string: this.quote_product.detail_attributes_string
          })
          .then((savedItem) => {
            this.productSaveCompleted();
          })
          .catch((error) => {
            alert(error.response ? error.response.data : error);
          });
    },
    productSaveCompleted(){
      if(confirm("Product successfully added. Do you want to proceed to Quote?")){
        this.$router.push({name: 'quote_path'});
      }
    },
    productBullets(node){
      let result = [];
      if(!!node.attribute_store['product_text_bullets']){
        const lines = node.attribute_store['product_text_bullets'].split(/\r?\n/);
        result.push(...lines);
      }
      return result;
    },
    productText(node){
      return node.attribute_store['product_text']
    },
    productTitle(node){
      return node.attribute_store['product_title']
    },
    productSubtitle(node){
      return node.attribute_store['product_subtitle']
    },
    productInfoHref(node){
      return node.attribute_store['product_info_href']
    }
  }
}
</script>

<style scoped>

</style>
